import { render, staticRenderFns } from "./bulma_map.vue?vue&type=template&id=2d012131&scoped=true&lang=html"
import script from "./bulma_map.vue?vue&type=script&lang=js"
export * from "./bulma_map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d012131",
  null
  
)

export default component.exports